import { useState, useEffect } from "react";
import CustomSelect from "./custom-select";
import SunIcon from "../assets/icons/sun.png";

export default function Switcher() {
    const [isDark, setIsDark] = useState(false);

    useEffect(() => {
        const htmlTag = document.documentElement;
        htmlTag.className = isDark ? "dark" : "light";
    }, [isDark]);

    const toggleTheme = () => {
        setIsDark(!isDark);
    };

    return (
        <div className="flex items-center justify-center md:gap-2 gap-1">
            <button
                onClick={toggleTheme}
                className="dropdown-toggle size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full  text-white hover:bg-orange-400"
                // className="w-15 h-15 md:w-12 md:h-12 rounded-full flex items-center justify-center bg-white dark:bg-slate-900 shadow"
            >
                <img
                    src={SunIcon}
                    alt="Toggle Theme"
                    className="w-full h-full md:w-full md:h-full object-contain"
                />
            </button>

            <div className="mb-2">
                <CustomSelect />
            </div>
        </div>
    );
}
